import React from "react";

import SegmentDashboard from "./SegmentDashboard";

const SegmentContainer = (props) => <SegmentDashboard {...props} />;

export default SegmentContainer;
